import { addTypenameToDocument } from "@apollo/client/utilities";
export default function addTypename(document) {
    return addTypenameToDocument(document);
}

//# sourceMappingURL=addTypename.js.map